import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

import { DRAWER_WIDTH, Sidebar } from '@occc-app/design-system';

import { SidebarProvider, useSidebar } from './SidebarContext';

const SidebarAppShellContent = () => {
  const { isSidebarOpen, onSidebarClose } = useSidebar();

  return (
    <>
      <Sidebar onClose={onSidebarClose} isOpen={isSidebarOpen} />
      <Box
        role='main'
        sx={{
          position: 'relative',
          height: '100%',
          overflowY: 'auto',
          transitionDuration: '.2s',
          transitionProperty: 'margin-left',
          marginLeft: {
            xs: 0,
            md: `${isSidebarOpen ? DRAWER_WIDTH : 0}px`,
          },
        }}
      >
        <Outlet />
      </Box>
    </>
  );
};

export const SidebarAppShell = () => {
  return (
    <SidebarProvider>
      <SidebarAppShellContent />
    </SidebarProvider>
  );
};
